export default {
  SOCKET_liveLogs(state, payload) {
    console.log("SOCKET_liveLogs", payload);
    state.items = payload;
  },
};
